/* eslint-disable linebreak-style */
import { bindMasksByAttribute } from 'br-input-masks';
import initA11y from './main/initA11y';
import initFormValidations from './main/initformValidation';
import initGallery from './main/initGallery';
import initVideos from './main/initVideos';
import initMenuFX from './main/initMenuFX';
import initModals from './main/initModals';
import initScrollFX from './main/initScrollFX';
import initSliders from './main/initSliders'

bindMasksByAttribute();

initA11y();

initFormValidations();

initMenuFX();

initSliders();

initGallery();

initVideos();

initModals();

initScrollFX();
